module.exports = __webpack_public_path__ + "media/images/athletes/129-0fe7f82dce33bb9def06164c26e852aa.png";